import { Toaster as Sonner } from 'sonner';

export function ToastProvider() {
  return <Sonner style={{ '--width': '50vw' } as React.CSSProperties} />;
}
